import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {Breadcrumb, Button, Icon, Table, Label, Form, Segment} from 'semantic-ui-react'
import {
    fetchQbTerms,
    fetchQbTaxes,
    fetchQbAccounts,
    fetchQbClasses,
    loadQbMapping,
    updateQbMappingModelInStore,
    updateQbMappingTaxLine
} from '../../actions/qb';
import {api} from '../../api'

class QbConfigPage extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            btnLoading: false
        }
    }

    componentDidMount() {
        const {jwt} = this.props;
        this.props.loadQbMapping(jwt);
        this.props.fetchQbAccounts(jwt, false);
        this.props.fetchQbClasses(jwt, false);
        this.props.fetchQbTaxes(jwt, false);
        this.props.fetchQbTerms(jwt, false);
    }

    onFormSubmit = () => {
        const {jwt, model} = this.props;
        this.setState({
            loading: true
        });
        api.integrations.updateQbMapping(jwt, model).then(res => {
            this.setState({
                loading: false
            });
        }).catch(err => {
            this.setState({
                loading: false
            });
        });
    }

    onUpdateTaxMapping = () => {
        const {jwt, wooTaxes} = this.props;
        this.setState({
            loading: true
        });
        api.integrations.updateQbTaxMapping(jwt, wooTaxes).then(res => {
            this.setState({
                loading: false
            });
        }).catch(err => {
            this.setState({
                loading: false
            });
        });
    }

    updateTaxLineMapping = (line, qbId) => {
        const {taxes} = this.props.lists;
        const {value} = line;
        const qbSelect = taxes.filter(item => {
            return parseInt(item.value) === parseInt(qbId);
        });
        if (_.isEmpty(qbSelect)) {
            return;
        }
        this.props.updateQbMappingTaxLine(value, qbId, qbSelect[0].text);
    }

    onReloadTaxClick = () => {
        this.setState({
            btnLoading: true
        });
        this.props.fetchQbTaxes(this.props.jwt, true).then(res => {
            this.setState({
                btnLoading: false
            });
        }).catch( err => {
            this.setState({
                btnLoading: false
            });
        });
    }

    onReloadTermClick = () => {
        this.setState({
            btnLoading: true
        });
        this.props.fetchQbTerms(this.props.jwt, true).then(res => {
            this.setState({
                btnLoading: false
            });
        }).catch( err => {
            this.setState({
                btnLoading: false
            });
        });
    }

    onReloadClassesClick = () => {
        this.setState({
            btnLoading: true
        });
        this.props.fetchQbClasses(this.props.jwt, true).then(res => {
            this.setState({
                btnLoading: false
            });
        }).catch( err => {
            this.setState({
                btnLoading: false
            });
        });
    }

    onReloadAccountsClick = () => {
        this.setState({
            btnLoading: true
        });
        this.props.fetchQbAccounts(this.props.jwt, true).then(res => {
            this.setState({
                btnLoading: false
            });
        }).catch( err => {
            this.setState({
                btnLoading: false
            });
        });
    }

    render() {
        const {model, lists, wooTaxes, updateQbMappingModelInStore} = this.props;
        const {taxes,classes,accounts} = lists;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Integrations
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                QuickBook
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                    <Form size="large">
                        <Segment>
                            <Form.Group unstackable widths={3}>
                                <Form.Select fluid search={true} label='Sales of Product Account' name='income_acct_id' options={accounts}
                                value={model.income_acct_id}
                                    onChange={(e,data) => { updateQbMappingModelInStore('income_acct_id', data.value) }}
                                />

                                <Form.Select fluid search={true} label='Cost of Goods Sold Account' name='expense_acct_id' options={accounts}
                                value={model.expense_acct_id}
                                    onChange={(e,data) => { updateQbMappingModelInStore('expense_acct_id', data.value) }}
                                />

                                <Form.Select fluid search={true} label='QB Inventory Asset Account' name='asset_acct_id' options={accounts}
                                value={model.asset_acct_id}
                                    onChange={(e,data) => { updateQbMappingModelInStore('asset_acct_id', data.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={3}>
                                <Form.Select fluid search={true} label='QB Inventory Class' name='inventory_class_id' options={classes}
                                    value={model.inventory_class_id}
                                    onChange={(e,data) => { updateQbMappingModelInStore('inventory_class_id', data.value) }}
                                />
                                <Form.Select fluid search={true} label='QB Service Class' name='service_class_id' options={classes}
                                    value={model.service_class_id}
                                    onChange={(e,data) => { updateQbMappingModelInStore('service_class_id', data.value) }}
                                />
                                <Form.Select fluid search={true} label='Account Payable Account (CAD)' name='ap_account_cad_id' options={accounts}
                                             value={model.ap_account_cad_id}
                                             onChange={(e,data) => { updateQbMappingModelInStore('ap_account_cad_id', data.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={3}>
                                <Form.Select fluid search={true} label='Account Payable Account (USD)' name='ap_account_usd_id' options={accounts}
                                             value={model.ap_account_usd_id}
                                             onChange={(e,data) => { updateQbMappingModelInStore('ap_account_usd_id', data.value) }}
                                />
                            </Form.Group>
                            <Button
                                color="teal"
                                onClick={this.onFormSubmit}
                                size="mini"
                                disabled={this.state.loading}
                            >
                                Save Mapping
                            </Button>
                            <div style={{float:'right'}}>
                                <Button
                                    color="purple"
                                    onClick={this.onReloadTaxClick}
                                    size="mini"
                                    disabled={this.state.btnLoading}
                                    loading={this.state.btnLoading}
                                >
                                    Reload Taxes
                                </Button>

                                <Button
                                    color="purple"
                                    onClick={this.onReloadAccountsClick}
                                    size="mini"
                                    disabled={this.state.btnLoading}
                                    loading={this.state.btnLoading}
                                >
                                    Reload Accounts
                                </Button>

                                <Button
                                    color="purple"
                                    onClick={this.onReloadClassesClick}
                                    size="mini"
                                    disabled={this.state.btnLoading}
                                    loading={this.state.btnLoading}
                                >
                                    Reload Classes
                                </Button>

                                <Button
                                    color="purple"
                                    onClick={this.onReloadTermClick}
                                    size="mini"
                                    disabled={this.state.btnLoading}
                                    loading={this.state.btnLoading}
                                >
                                    Reload Terms
                                </Button>
                            </div>
                        </Segment>
                    </Form>
                    </div>
                </div>
                <div className="row" style={{marginTop: '10px'}}>
                    <div className="col-md-12">
                        <Segment>
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                            Tax Name (Woo)
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Tax Rate (Woo)
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            QB Map
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            QB Name
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {wooTaxes.map(i => {
                                        if (i.key !== 'NA') {
                                            return (
                                                <Table.Row key={i.key}>
                                                    <Table.Cell>
                                                        {i.text}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {Math.round(i.rate * 100)} %
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Form.Select fluid search={true} name='qb_line' options={taxes}
                                                            value={i.acct_id}
                                                            onChange={(e,data) => { this.updateTaxLineMapping(i, data.value) }}
                                                        />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {i.acct_name ? i.acct_name : ""}
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        }
                                    })}
                                </Table.Body>
                            </Table>
                            <Button
                                color="teal"
                                onClick={this.onUpdateTaxMapping}
                                size="mini"
                                disabled={this.state.loading}
                            >
                                Save Tax Mapping
                            </Button>
                        </Segment>
                    </div>
                </div>
            </div>
        )
    }
}

QbConfigPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchQbTerms: PropTypes.func.isRequired,
    fetchQbTaxes: PropTypes.func.isRequired,
    fetchQbAccounts: PropTypes.func.isRequired,
    fetchQbClasses: PropTypes.func.isRequired,
    loadQbMapping: PropTypes.func.isRequired,
    updateQbMappingModelInStore: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    lists: PropTypes.object.isRequired,
    wooTaxes: PropTypes.array.isRequired,
    jwt: PropTypes.string.isRequired,
    updateQbMappingTaxLine:PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.qb.model,
        lists: state.qb.lists,
        wooTaxes: state.system.resources.taxes
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchQbTerms,
        fetchQbTaxes,
        fetchQbAccounts,
        fetchQbClasses,
        loadQbMapping,
        updateQbMappingModelInStore,
        updateQbMappingTaxLine
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QbConfigPage)



// WEBPACK FOOTER //
// ./src/components/settings/QbConfig.js